import { type NextPage } from 'next';

import SignUp from '@/components/SignUp';

const SignUpPage: NextPage = () => {
  return <SignUp />;
};

export default SignUpPage;
